import prop from 'ramda/src/prop'
import memoizeWith from 'ramda/src/memoizeWith'

import embeddedContentSelector from 'root/src/client/logic/header/selectors/embeddedContentSelector'

export default memoizeWith(
	(state, { moduleId }) => moduleId,
	(state, props) => prop('fields', embeddedContentSelector(state, props)),
)
